export default __webpack_public_path__ + "static/media/audi-box.b3263089.png";